export default __webpack_public_path__ + "static/media/locusofcontrol6Img2.52e671bc.png";